module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// object to store loaded chunks
/******/ 	// "0" means "already loaded"
/******/ 	var installedChunks = {
/******/ 		15: 0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_inner_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_inner_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_inner_require__.e = function requireEnsure(chunkId) {
/******/ 		// "0" is the signal for "already loaded"
/******/ 		if(installedChunks[chunkId] !== 0) {
/******/ 			return import("./wix-music-widget-" + chunkId + ".js").then(function (chunk) {
/******/ 				var moreModules = chunk.modules, chunkIds = chunk.ids;
/******/ 				for(var moduleId in moreModules) {
/******/ 					modules[moduleId] = moreModules[moduleId];
/******/ 				}
/******/ 				for(var i = 0; i < chunkIds.length; i++)
/******/ 					installedChunks[chunkIds[i]] = 0;
/******/ 			});
/******/ 		}
/******/ 		return Promise.resolve();
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_inner_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_inner_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_inner_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_inner_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_inner_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_inner_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_inner_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_inner_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_inner_require__.p = "";
/******/
/******/ 	// uncatched error handler for webpack runtime
/******/ 	__webpack_inner_require__.oe = function(err) {
/******/ 		process.nextTick(function() {
/******/ 			throw err; // catch this error by using System.import().catch()
/******/ 		});
/******/ 	};
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_inner_require__(__webpack_inner_require__.s = 371);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/* no static exports found */
/* all exports used */
/*!**************************!*\
  !*** external "mithril" ***!
  \**************************/
/***/ (function(module, exports) {

module.exports = require("mithril");

/***/ }),

/***/ 1:
/* no static exports found */
/* all exports used */
/*!********************************!*\
  !*** ./scripts/utils/utils.js ***!
  \********************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.utils = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _desc, _value, _obj;

exports.camelCase = camelCase;

var _wixSdk = __webpack_require__(/*! ../common/wix-sdk */ 5);

var Wix = _interopRequireDefault(_wixSdk).default;

var _constants = __webpack_require__(/*! ../common/constants */ 2);

var constants = _interopRequireDefault(_constants).default;

var _config = __webpack_require__(/*! ../common/config */ 3);

var config = _interopRequireDefault(_config).default;

var _sendRequest = __webpack_require__(/*! ./send-request */ 39);

var sendRequest = _sendRequest.sendRequest;

var _deprecated = __webpack_require__(/*! ./deprecated */ 7);

var deprecated = _deprecated.deprecated;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

function createRegexp(t, options) {
  t = t.replace(/[()\[\]\.^$|?+]/g, '\\$&');
  return new RegExp(t, options);
}

var SPECIAL_CHARS_REGEXP = /([\:\-\_]+(.))/g;
function camelCase(name) {
  return name.replace(SPECIAL_CHARS_REGEXP, function (_, separator, letter, offset) {
    return offset ? letter.toUpperCase() : letter;
  });
}

var utils = exports.utils = (_obj = {
  getObjectType: function getObjectType(obj) {
    return Object.prototype.toString.call(obj).split(' ')[1].slice(0, -1);
  },
  isObjectAndNotNullOrArray: function isObjectAndNotNullOrArray(obj) {
    return (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object' && obj !== null && !Array.isArray(obj);
  },
  durationToString: function durationToString(duration) {
    var chunks = [];
    var chunk = void 0;
    duration = Math.floor(duration);
    do {
      chunk = duration % 60;
      if (chunk <= 9) {
        chunk = '0' + chunk;
      }
      chunks.unshift(chunk);
      duration = Math.floor(duration / 60);
    } while (duration > 0);

    if (chunks.length < 2) {
      chunks.unshift('00');
    }

    return chunks.join(':');
  },
  stringToDuration: function stringToDuration(durationString) {
    if (!durationString) {
      return 0;
    }
    return durationString.split(':').reverse().reduce(function (duration, chunk, i) {
      return duration + chunk * Math.pow(60, i);
    }, 0);
  },
  forEach: function forEach(object, callback) {
    var objectIterator = function objectIterator(key) {
      var value = object[key];
      var result = callback.call(value, key, value);
      if (typeof result === 'boolean') {
        return result;
      }
      return true;
    };

    var listIterator = function listIterator(value, index) {
      var result = callback.call(value, value, index);
      if (typeof result === 'boolean') {
        return result;
      }
      return true;
    };

    if (utils.getObjectType(object) === 'Object' || object.length === undefined) {
      Object.keys(object).every(objectIterator);
      return;
    }

    if (Array.isArray(object)) {
      object.every(listIterator);
      return;
    }

    [].every.call(object, listIterator);
  },
  find: function find(array, predicate) {
    var foundElement = void 0;
    utils.forEach(array, function (element, index) {
      if (predicate(element, index)) {
        foundElement = element;
        return false;
      }
    });
    return foundElement;
  },
  includes: function includes(array, element) {
    return [].some.call(array, function (value) {
      return value === element;
    });
  },
  filter: function filter(array, predicate) {
    return [].filter.call(array, predicate);
  },


  // extend is not recursive
  extend: function extend(destination) {
    if (!utils.isObjectAndNotNullOrArray(destination)) {
      destination = {};
    }

    for (var _len = arguments.length, sources = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      sources[_key - 1] = arguments[_key];
    }

    sources.forEach(function (source) {
      if (!utils.isObjectAndNotNullOrArray(source)) {
        return;
      }

      utils.forEach(source, function (prop) {
        destination[prop] = source[prop];
      });
    });

    return destination;
  },


  // merge is recursive
  merge: function merge(destination) {
    if (!utils.isObjectAndNotNullOrArray(destination)) {
      destination = {};
    }

    for (var _len2 = arguments.length, sources = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      sources[_key2 - 1] = arguments[_key2];
    }

    sources.forEach(function (source) {
      if (!utils.isObjectAndNotNullOrArray(source)) {
        return;
      }

      utils.forEach(source, function (prop) {
        if (utils.isObjectAndNotNullOrArray(source[prop])) {
          destination[prop] = utils.merge(destination[prop], source[prop]);
          return;
        }

        destination[prop] = source[prop];
      });
    });

    return destination;
  },


  // defaults is recursive
  defaults: function defaults(destination) {
    if (!utils.isObjectAndNotNullOrArray(destination)) {
      destination = {};
    }

    var hop = {}.hasOwnProperty;

    for (var _len3 = arguments.length, sources = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
      sources[_key3 - 1] = arguments[_key3];
    }

    sources.forEach(function (source) {
      utils.forEach(source, function (prop) {
        if (hop.call(destination, prop) && destination[prop] !== undefined && !utils.isObjectAndNotNullOrArray(destination[prop])) {
          return;
        }

        if (utils.isObjectAndNotNullOrArray(source[prop])) {
          destination[prop] = utils.defaults(destination[prop], source[prop]);
          return;
        }

        destination[prop] = source[prop];
      });
    });

    return destination;
  },
  insertDataInTemplate: function insertDataInTemplate(template) {
    for (var _len4 = arguments.length, dataSources = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
      dataSources[_key4 - 1] = arguments[_key4];
    }

    dataSources.forEach(function (dataSource) {
      utils.forEach(dataSource, function (key, value) {
        template = template.replace(createRegexp('#' + key + '#', 'g'), value);
      });
    });

    return template;
  },
  getUrlParam: function getUrlParam(name, url) {
    var pairsSep = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '&';
    var valuesSep = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '=';

    var matched = new RegExp('(?:^|[?' + pairsSep + '])\\s*?' + name + valuesSep + '([^' + pairsSep + ']*)').exec(url || document.location.href);
    if (!matched) {
      return '';
    }
    return matched[1].trim();
  },
  params: function params(data) {
    var getParams = [];
    utils.forEach(data, function (key, value) {
      if (value !== undefined) {
        getParams.push(key + '=' + encodeURIComponent(value));
      }
    });
    return getParams.join('&');
  },
  getJSON: function getJSON(url) {
    return sendRequest({ method: 'GET', url: url }).then(function (response) {
      return response.data;
    });
  },
  postJSON: function postJSON(url, data) {
    return sendRequest({ method: 'POST', url: url, data: data });
  },
  openPopup: function openPopup(url, width, height) {
    var left = (window.screen.width - width) / 2,
        top = (window.screen.height - height) / 2;

    var win = window.open(url, '_blank', 'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=' + width + ', height=' + height + ', top=' + top + ', left=' + left);

    if (win) {
      if (win.moveTo) {
        win.moveTo(left, top);
      }
      win.focus();
    }
  },
  buildScaledImageUrl: function buildScaledImageUrl(originalUrl, mode, width, height) {
    width = Math.round(width);
    height = Math.round(height);
    var file = originalUrl.split('/').pop();

    var _file$split = file.split('.'),
        _file$split2 = _slicedToArray(_file$split, 2),
        fileName = _file$split2[0],
        fileExtension = _file$split2[1];

    var sourceName = config.imageUrls.sourceName;

    var urlStart = originalUrl + '/v1/' + mode + '/w_' + width + ',h_' + height;
    var urlEnd = fileName + '_' + sourceName + '.' + fileExtension;

    if (/jpe?g/i.test(fileExtension)) {
      var jpgParams = config.imageUrls.jpgParams;
      return urlStart + ',q_' + jpgParams.q + ',usm_' + jpgParams.usm + '/' + urlEnd;
    }

    return urlStart + '/' + urlEnd;
  },
  isAbsoluteUrl: function isAbsoluteUrl(url) {
    return (/^(https?:)?\/\//.test(url)
    );
  },
  isMobileView: function isMobileView() {
    return Boolean(Wix && Wix.Utils && Wix.Utils.getDeviceType() === constants.DEVICE_TYPES.MOBILE);
  },
  isString: function isString(value) {
    return typeof value === 'string' || value instanceof String;
  },
  isFunction: function isFunction(value) {
    return typeof value === 'function';
  },
  getHostAndPath: function getHostAndPath(withProtocol) {
    var protocol = withProtocol ? location.protocol : '';
    var host = location.host;
    var pathName = location.pathname.replace(/[^/]+$/, '');
    return protocol + '//' + host + pathName;
  },
  loadImage: function loadImage(src) {
    return new Promise(function (resolve, reject) {
      var img = new Image();
      img.onload = function () {
        resolve(img);
      };
      img.onerror = function () {
        reject(img);
      };
      img.src = src;
    });
  },
  encodeHTML: function encodeHTML(html) {
    var encodeHTMLRules = { '&': '&#38;', '<': '&#60;', '>': '&#62;', '"': '&#34;', '\'': '&#39;', '/': '&#47;' };
    var matchHTML = /&(?!#?\w+;)|<|>|"|'|\//g;

    if (!html) {
      return '';
    }

    return html.toString().replace(matchHTML, function (m) {
      return encodeHTMLRules[m] || m;
    });
  },


  /**
   * Modulo operation returning always a positive remainder.
   * mod(-1, 5) === 4
   * @param a {number} dividend
   * @param b {number} divisor
   * @returns {number} positive remainder
   */
  mod: function mod(a, b) {
    //noinspection Eslint
    return (b + a % b) % b;
  },
  noop: function noop() {}
}, (_applyDecoratedDescriptor(_obj, 'isMobileView', [deprecated], Object.getOwnPropertyDescriptor(_obj, 'isMobileView'), _obj)), _obj);

exports.default = utils;

/***/ }),

/***/ 10:
/* no static exports found */
/* all exports used */
/*!******************************************!*\
  !*** ./scripts/app-status/app-status.js ***!
  \******************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.appStatus = exports.AppStatus = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _events = __webpack_require__(/*! events */ 8);

var EventEmitter = _interopRequireDefault(_events).default;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AppStatus = exports.AppStatus = function (_EventEmitter) {
  _inherits(AppStatus, _EventEmitter);

  function AppStatus() {
    _classCallCheck(this, AppStatus);

    return _possibleConstructorReturn(this, (AppStatus.__proto__ || Object.getPrototypeOf(AppStatus)).apply(this, arguments));
  }

  _createClass(AppStatus, [{
    key: 'report',
    value: function report(name, attributes) {
      this.emit('metric', name, attributes);
    }
  }]);

  return AppStatus;
}(EventEmitter);

var appStatus = exports.appStatus = new AppStatus();

/***/ }),

/***/ 12:
/* no static exports found */
/* all exports used */
/*!************************!*\
  !*** ../env/prod.json ***!
  \************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
	"dgs": "//dgs.wixapps.net/",
	"currenciesUrl": "http://dgs.wixapps.net/pp/paypal_currencies"
};

/***/ }),

/***/ 13:
/* no static exports found */
/* all exports used */
/*!*******************************!*\
  !*** ./scripts/_bootstrap.js ***!
  \*******************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(/*! ./utils/polyfills */ 37);

/* global WIX_MUSIC_WIDGET_PUBLIC_PATH:false */

if (typeof WIX_MUSIC_WIDGET_PUBLIC_PATH !== 'undefined') {
  __webpack_require__.p = WIX_MUSIC_WIDGET_PUBLIC_PATH;
}

/***/ }),

/***/ 145:
/* no static exports found */
/* all exports used */
/*!**********************************!*\
  !*** external "lodash/uniqueId" ***!
  \**********************************/
/***/ (function(module, exports) {

module.exports = require("lodash/uniqueId");

/***/ }),

/***/ 146:
/* no static exports found */
/* all exports used */
/*!***************************************!*\
  !*** ./scripts/common/get-version.js ***!
  \***************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getVersion = getVersion;
function getVersion(widgetSettings) {
  var defaultVersion = 3;
  var styleParamsVersion = widgetSettings.numbers && widgetSettings.numbers['wmp::styleParamsVersion'];
  var isMigrated = widgetSettings.booleans && widgetSettings.booleans['wmp::isMigrated'];

  return styleParamsVersion || (isMigrated ? 1 : defaultVersion);
}

/***/ }),

/***/ 15:
/* no static exports found */
/* all exports used */
/*!***********************************************************!*\
  !*** ./scripts/player/v2/shared/errors/error-reporter.js ***!
  \***********************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.errorReporter = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _events = __webpack_require__(/*! events */ 8);

var EventEmitter = _interopRequireDefault(_events).default;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ErrorReporter = function (_EventEmitter) {
  _inherits(ErrorReporter, _EventEmitter);

  function ErrorReporter() {
    _classCallCheck(this, ErrorReporter);

    return _possibleConstructorReturn(this, (ErrorReporter.__proto__ || Object.getPrototypeOf(ErrorReporter)).apply(this, arguments));
  }

  _createClass(ErrorReporter, [{
    key: 'emit',
    value: function emit(errorDescription) {
      try {
        _get(ErrorReporter.prototype.__proto__ || Object.getPrototypeOf(ErrorReporter.prototype), 'emit', this).apply(this, arguments);
      } catch (ex) {
        if (ex.message === 'Uncaught, unspecified "error" event.') {
          var _console;

          (_console = console).error.apply(_console, ['Error: ' + errorDescription.name].concat(Array.prototype.slice.call(arguments))); // eslint-disable-line  no-console
          return;
        }
        throw ex;
      }
    }
  }, {
    key: 'report',
    value: function report(errorDescriptor, errorArgs) {
      this.emit('error', errorDescriptor, errorArgs);
    }
  }, {
    key: 'createPromiseErrorHandler',
    value: function createPromiseErrorHandler(errorDescriptor) {
      var _this2 = this;

      return function (reason) {
        _this2.report(errorDescriptor, { reason: reason });
        return Promise.reject(reason);
      };
    }
  }]);

  return ErrorReporter;
}(EventEmitter);

var errorReporter = new ErrorReporter();

exports.errorReporter = errorReporter;

/***/ }),

/***/ 2:
/* no static exports found */
/* all exports used */
/*!*************************************!*\
  !*** ./scripts/common/constants.js ***!
  \*************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _constants$MUSIC_VERS, _constants$TRACK_VERS;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var constants = {
  PREVIEW_TYPES: {
    FULL: 'FULL',
    PREVIEW_30: 'PREVIEW_30'
  },
  PREVIEW_LENGTH: {
    PREVIEW_30: 30
  },
  MUSIC_VERSIONS: {
    EMPTY: 'EMPTY',
    REMIXES: 'REMIXES',
    REMASTERED: 'REMASTERED',
    CLEAN: 'CLEAN',
    LIVE: 'LIVE',
    BONUS: 'BONUS',
    DELUXE: 'DELUXE',
    SPECIAL: 'SPECIAL',
    ACOUSTIC: 'ACOUSTIC',
    DEMO: 'DEMO'
  },
  TRACK_VERSIONS: {
    EMPTY: 'EMPTY',
    CLEAN: 'CLEAN',
    EDITED: 'EDITED',
    BONUS: 'BONUS',
    EXPLICIT: 'EXPLICIT',
    DIRTY: 'DIRTY',
    ACOUSTIC: 'ACOUSTIC',
    DEMO: 'DEMODEMO', // for some reason it was saved like this...
    LIVE: 'LIVE',
    RADIO: 'RADIO'
  },
  DEVICE_TYPES: {
    MOBILE: 'mobile'
  },
  VIEW_MODES: {
    EDITOR: 'editor',
    SITE: 'site',
    STANDALONE: 'standalone',
    PREVIEW: 'preview',
    DASHBOARD: 'dashboard' // opens in shout out
  },
  TRACK_PAGE_DIMENSIONS: {
    WIDTH: 775,
    HEIGHT: 630
  },
  ALBUM_TYPES: {
    ALBUM: 'ALBUM',
    SINGLE: 'SINGLE',
    PLAYLIST: 'PLAYLIST'
  }
};

constants.MUSIC_VERSIONS_LABELS = (_constants$MUSIC_VERS = {}, _defineProperty(_constants$MUSIC_VERS, constants.MUSIC_VERSIONS.EMPTY, 'player_music_album_versions_empty'), _defineProperty(_constants$MUSIC_VERS, constants.MUSIC_VERSIONS.REMIXES, 'player_music_album_versions_remixes'), _defineProperty(_constants$MUSIC_VERS, constants.MUSIC_VERSIONS.REMASTERED, 'player_music_album_versions_remastered'), _defineProperty(_constants$MUSIC_VERS, constants.MUSIC_VERSIONS.CLEAN, 'player_music_album_versions_clean'), _defineProperty(_constants$MUSIC_VERS, constants.MUSIC_VERSIONS.LIVE, 'player_music_album_versions_live'), _defineProperty(_constants$MUSIC_VERS, constants.MUSIC_VERSIONS.BONUS, 'player_music_album_versions_bonus'), _defineProperty(_constants$MUSIC_VERS, constants.MUSIC_VERSIONS.DELUXE, 'player_music_album_versions_deluxe'), _defineProperty(_constants$MUSIC_VERS, constants.MUSIC_VERSIONS.SPECIAL, 'player_music_album_versions_special'), _defineProperty(_constants$MUSIC_VERS, constants.MUSIC_VERSIONS.ACOUSTIC, 'player_music_album_versions_acoustic'), _defineProperty(_constants$MUSIC_VERS, constants.MUSIC_VERSIONS.DEMO, 'player_music_album_versions_demo'), _constants$MUSIC_VERS);

constants.TRACK_VERSIONS_LABELS = (_constants$TRACK_VERS = {}, _defineProperty(_constants$TRACK_VERS, constants.TRACK_VERSIONS.EMPTY, 'player_track_versions_empty'), _defineProperty(_constants$TRACK_VERS, constants.TRACK_VERSIONS.CLEAN, 'player_track_versions_clean'), _defineProperty(_constants$TRACK_VERS, constants.TRACK_VERSIONS.EDITED, 'player_track_versions_edited'), _defineProperty(_constants$TRACK_VERS, constants.TRACK_VERSIONS.BONUS, 'player_track_versions_bonus'), _defineProperty(_constants$TRACK_VERS, constants.TRACK_VERSIONS.EXPLICIT, 'player_track_versions_explicit'), _defineProperty(_constants$TRACK_VERS, constants.TRACK_VERSIONS.DIRTY, 'player_track_versions_dirty'), _defineProperty(_constants$TRACK_VERS, constants.TRACK_VERSIONS.ACOUSTIC, 'player_track_versions_acoustic'), _defineProperty(_constants$TRACK_VERS, constants.TRACK_VERSIONS.DEMO, 'player_track_versions_demo'), _defineProperty(_constants$TRACK_VERS, constants.TRACK_VERSIONS.LIVE, 'player_track_versions_live'), _defineProperty(_constants$TRACK_VERS, constants.TRACK_VERSIONS.RADIO, 'player_track_versions_radio'), _constants$TRACK_VERS);

exports.default = constants;

/***/ }),

/***/ 283:
/* no static exports found */
/* all exports used */
/*!************************************!*\
  !*** external "perfect-scrollbar" ***!
  \************************************/
/***/ (function(module, exports) {

module.exports = require("perfect-scrollbar");

/***/ }),

/***/ 292:
/* no static exports found */
/* all exports used */
/*!**************************!*\
  !*** ./scripts/index.js ***!
  \**************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.appStatus = exports.errorReporter = undefined;

var _errorReporter = __webpack_require__(/*! ./player/v2/shared/errors/error-reporter */ 15);

Object.defineProperty(exports, 'errorReporter', {
  enumerable: true,
  get: function get() {
    return _errorReporter.errorReporter;
  }
});

var _appStatus = __webpack_require__(/*! ./app-status/app-status */ 10);

Object.defineProperty(exports, 'appStatus', {
  enumerable: true,
  get: function get() {
    return _appStatus.appStatus;
  }
});
exports.init = init;

var _getVersion = __webpack_require__(/*! ./common/get-version */ 146);

var getVersion = _getVersion.getVersion;

var _initByCollectionIdFn = __webpack_require__(/*! ./player/init-by-collection-id-fn */ 50);

var initByCollectionIdFn = _interopRequireDefault(_initByCollectionIdFn).default;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function init(element, options) {
  var isMobileView = options.isMobileView;
  var version = getVersion(options);
  var initPromise = __webpack_require__(/*! ./player */ 370)("./init-" + (isMobileView ? 'mobile' : 'desktop') + '-v' + version).then(function (module) {
    return module.default;
  });

  return new Promise(function (resolve, reject) {
    initPromise.catch(reject);
    initByCollectionIdFn(initPromise)(element, options, options.albumId, function (result) {
      if (result instanceof Error) {
        reject(result);
      } else {
        resolve(result);
      }
    });
  });
}

/***/ }),

/***/ 3:
/* no static exports found */
/* all exports used */
/*!**********************************!*\
  !*** ./scripts/common/config.js ***!
  \**********************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _require = __webpack_require__(/*! env-config */ 12),
    dgs = _require.dgs;

var config = {
  hosts: {
    collections: '//collections.wixstatic.com/',
    legacyCollections: '//static.wixstatic.com/',
    audios: '//static.wixstatic.com/preview/',
    images: '//static.wixstatic.com/',
    bi: 'https://frog.wix.com/music-ugc',
    currencies: '//dgs.wixapps.net/pp/paypal_currencies',
    dgs: dgs
  },
  files: {
    trackPage: 'widget-track.html',
    featureDisabledPage: 'widget-feature-disabled.html',
    fbRedirectPage: 'fb-redirect.html'
  },
  htmlIds: {
    albumPage: 'WixMusicPlayerWidget',
    trackPage: 'WixMusicTrackPage'
  },
  htmlTags: {
    albumPage: 'wix-pl-app',
    trackPage: 'wix-pl-track'
  },
  imageUrls: {
    sourceName: 'mscwdt',
    jpgParams: {
      q: 85,
      usm: '0.66_1.00_0.01'
    }
  }
};

exports.default = config;

/***/ }),

/***/ 343:
/* no static exports found */
/* all exports used */
/*!***************************!*\
  !*** external "clamp-js" ***!
  \***************************/
/***/ (function(module, exports) {

module.exports = require("clamp-js");

/***/ }),

/***/ 37:
/* no static exports found */
/* all exports used */
/*!******************************************!*\
  !*** ./scripts/utils/polyfills/index.js ***!
  \******************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(/*! ./raf-polyfill */ 38);

/***/ }),

/***/ 370:
/* no static exports found */
/* all exports used */
/*!********************************************!*\
  !*** ./scripts/player lazy ^\.\/init\-.*$ ***!
  \********************************************/
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./init-by-collection-id-fn": [
		50
	],
	"./init-by-collection-id-fn.js": [
		50
	],
	"./init-desktop": [
		285,
		0
	],
	"./init-desktop-v1": [
		284,
		6
	],
	"./init-desktop-v1.js": [
		284,
		6
	],
	"./init-desktop-v2": [
		269,
		2
	],
	"./init-desktop-v2.js": [
		269,
		2
	],
	"./init-desktop-v3": [
		270,
		1
	],
	"./init-desktop-v3.js": [
		270,
		1
	],
	"./init-desktop.js": [
		285,
		0
	],
	"./init-mobile": [
		273,
		3
	],
	"./init-mobile-v1": [
		275,
		7
	],
	"./init-mobile-v1.js": [
		275,
		7
	],
	"./init-mobile-v2": [
		276,
		5
	],
	"./init-mobile-v2.js": [
		276,
		5
	],
	"./init-mobile-v3": [
		277,
		4
	],
	"./init-mobile-v3.js": [
		277,
		4
	],
	"./init-mobile.js": [
		273,
		3
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
module.exports = webpackAsyncContext;
webpackAsyncContext.id = 370;

/***/ }),

/***/ 371:
/* no static exports found */
/* all exports used */
/*!********************************************************!*\
  !*** multi ./scripts/_bootstrap.js ./scripts/index.js ***!
  \********************************************************/
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(/*! ./scripts/_bootstrap.js */13);
module.exports = __webpack_require__(/*! ./scripts/index.js */292);


/***/ }),

/***/ 38:
/* no static exports found */
/* all exports used */
/*!*************************************************!*\
  !*** ./scripts/utils/polyfills/raf-polyfill.js ***!
  \*************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// http://paulirish.com/2011/requestanimationframe-for-smart-animating/
// http://my.opera.com/emoller/blog/2011/12/20/requestanimationframe-for-smart-er-animating

// requestAnimationFrame polyfill by Erik Möller. fixes from Paul Irish and Tino Zijdel

// MIT license

(function () {
  var lastTime = 0;
  var vendors = ['ms', 'moz', 'webkit', 'o'];
  for (var x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
    window.requestAnimationFrame = window[vendors[x] + 'RequestAnimationFrame'];
    window.cancelAnimationFrame = window[vendors[x] + 'CancelAnimationFrame'] || window[vendors[x] + 'CancelRequestAnimationFrame'];
  }

  if (!window.requestAnimationFrame) window.requestAnimationFrame = function (callback) {
    var currTime = new Date().getTime();
    var timeToCall = Math.max(0, 16 - (currTime - lastTime));
    var id = window.setTimeout(function () {
      callback(currTime + timeToCall);
    }, timeToCall);
    lastTime = currTime + timeToCall;
    return id;
  };

  if (!window.cancelAnimationFrame) window.cancelAnimationFrame = function (id) {
    clearTimeout(id);
  };
})();

/***/ }),

/***/ 39:
/* no static exports found */
/* all exports used */
/*!***************************************!*\
  !*** ./scripts/utils/send-request.js ***!
  \***************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.sendRequest = sendRequest;
// if you change anything here, please also update copy in wix-music-dashboards app/modules/widget/utils/send-request.js
function sendRequest(options) {
  options = _extends({
    method: 'GET',
    type: 'json'
  }, options);

  if (!options.url) {
    throw new TypeError('url is not specified');
  }

  if (options.type === 'json') {
    options = withJsonDefaults(options);
  }

  var _options = options,
      method = _options.method,
      url = _options.url,
      data = _options.data,
      params = _options.params,
      headers = _options.headers;

  var parametrizedUrl = createParametrizeUrl(url, params);

  return new Promise(function (resolve, reject) {
    var request = new XMLHttpRequest();

    request.addEventListener('load', function () {
      var response = { status: request.status, text: request.responseText };
      try {
        response.data = parseResponseBody(request);
      } catch (reason) {
        reject(reason);
      }
      if (request.status < 200 || request.status > 299) {
        reject(response);
        return;
      }
      resolve(response);
    });

    function onError(status, text) {
      return function () {
        reject({ status: status, text: text });
      };
    }

    request.addEventListener('error', onError(-100, 'error'));
    request.addEventListener('abort', onError(-200, 'aborted'));

    request.open(method, parametrizedUrl, true);
    Object.keys(headers).forEach(function (header) {
      request.setRequestHeader(header, headers[header]);
    });
    request.send(data);
  });
}

function withJsonDefaults(options) {
  function getHeaders() {
    var headers = {
      Accept: 'application/json'
    };
    if (options.method === 'POST') {
      headers['Content-Type'] = 'application/json; charset=utf-8';
    }
    return _extends({}, headers, options.headers);
  }

  function getData() {
    var data = options.data;
    return data && (typeof data === 'undefined' ? 'undefined' : _typeof(data)) === 'object' ? JSON.stringify(data) : data;
  }

  return _extends({}, options, {
    headers: getHeaders(),
    data: getData()
  });
}

function createParametrizeUrl(url, params) {
  if (!params || !Object.keys(params).length) {
    return url;
  }

  if (url.indexOf('?') !== -1) {
    throw new TypeError('Adding param to urls with params is not supported');
  }
  var stringifiedParams = WMP.utils.createParam(params);
  return url + '?' + stringifiedParams;
}

function parseResponseBody(request) {
  if (request.getResponseHeader('Content-Type') === 'application/json') {
    try {
      return JSON.parse(request.responseText);
    } catch (ex) {
      throw new Error('Cannot parse response body');
    }
  }
  return request.responseText;
}

/***/ }),

/***/ 49:
/* no static exports found */
/* all exports used */
/*!************************************!*\
  !*** ./scripts/common/migrator.js ***!
  \************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (widgetSettings, fallbackSettings) {
  var mergedSettings = utils.merge({}, widgetSettings);

  if (!fallbackSettings) {
    return mergedSettings;
  }

  mergedSettings.booleans = utils.merge(mergedSettings.booleans, fallbackSettings.booleans);
  mergedSettings.numbers = utils.merge(mergedSettings.numbers, fallbackSettings.numbers);
  mergedSettings.fonts = mergedSettings.fonts || {};

  utils.forEach(['siteOwnerId', 'paymentsId'], function (keyName) {
    var wmpKey = 'wmp::' + keyName;
    if (fallbackSettings.fonts[keyName]) {
      mergedSettings.fonts[wmpKey] = fallbackSettings.fonts[keyName];
    }
  });

  return mergedSettings;
};

var _utils = __webpack_require__(/*! ./../utils/utils */ 1);

var utils = _interopRequireDefault(_utils).default;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 5:
/* no static exports found */
/* all exports used */
/*!***********************************!*\
  !*** ./scripts/common/wix-sdk.js ***!
  \***********************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var WixSdk = void 0;
if (typeof Wix !== 'undefined' && Wix.PubSub) {
  // Wix.PubSub to check that Wix is wix-sdk's Wix
  WixSdk = {
    Activities: {
      Type: Wix.Activities.Type,
      postActivity: Wix.Activities.postActivity
    },
    Counters: Wix.Counters,
    Styles: Wix.Styles,
    Theme: Wix.Theme,
    Utils: Wix.Utils,
    WindowOrigin: Wix.WindowOrigin,
    WindowPlacement: Wix.WindowPlacement
  };

  module.exports = WixSdk;
}

exports.default = WixSdk;

/***/ }),

/***/ 50:
/* no static exports found */
/* all exports used */
/*!****************************************************!*\
  !*** ./scripts/player/init-by-collection-id-fn.js ***!
  \****************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (init) {
  return function (domElement, widgetSettings, albumCollectionId, callback) {
    if (isPlainObject(domElement)) {
      var _ref = [null, domElement, widgetSettings, albumCollectionId];
      domElement = _ref[0];
      widgetSettings = _ref[1];
      albumCollectionId = _ref[2];
      callback = _ref[3];
    } else if (typeof domElement === 'string') {
      var foundElement = document.querySelector(domElement);
      if (!foundElement) {
        throw new Error('Cannot find element by selector ' + domElement);
      }
      domElement = foundElement;
    } else if (domElement[0] !== undefined) {
      domElement = domElement[0];
    }

    if (!domElement) {
      domElement = document.querySelector('wix-pl-app, .wix-pl-app');

      if (!domElement) {
        throw new Error('Cannot find element wix-pl-app');
      }
    }

    if (!window.getComputedStyle) {
      callback(new Error('Browser Not Supported'));
      return;
    }

    widgetSettings = utils.merge({}, widgetSettings);

    function initPlayer(settingsCollection, albumCollection) {
      Promise.resolve(init).then(function (resolvedInit) {
        resolvedInit(domElement, settingsCollection, albumCollection, callback);
      });
    }

    function getAlbumCollection(settings) {
      if (!albumCollectionId) {
        throw new Error('Please provide valid collection id');
      }

      var settingsCollectionId = settings.settingsCollectionId;


      var settingsPromise = void 0;
      if (!settingsCollectionId) {
        settingsPromise = Promise.resolve(settings);
      } else {
        settingsPromise = utils.getJSON(config.hosts.collections + 'collections/' + settingsCollectionId + '.json').catch(errorReporter.createPromiseErrorHandler(BI_ERRORS.widget.settingsCollection.get)).then(function (_ref2) {
          var collection = _ref2.collection;

          return utils.merge(settings, collection.public_properties);
        });
      }

      var albumPromise = utils.getJSON(config.hosts.collections + 'collections/' + albumCollectionId + '.json').catch(errorReporter.createPromiseErrorHandler(BI_ERRORS.widget.musicAlbum.get)).then(function (_ref3) {
        var collection = _ref3.collection;

        return collection;
      });

      Promise.all([settingsPromise, albumPromise]).then(function (collections) {
        initPlayer.apply(undefined, _toConsumableArray(collections));
      });
    }

    if (widgetSettings && widgetSettings.booleans && !widgetSettings.booleans['wmp::isMigrated'] && widgetSettings.instanceId && widgetSettings.compId) {
      utils.getJSON(config.hosts.legacyCollections + 'legacy-player/' + widgetSettings.instanceId + '-' + widgetSettings.compId + '.json').then(function (fallbackSettings) {
        var mergedSettings = migrator(widgetSettings, fallbackSettings);

        if (fallbackSettings && fallbackSettings.fonts && fallbackSettings.fonts.albumId) {
          albumCollectionId = fallbackSettings.fonts.albumId.value || albumCollectionId;
        }

        getAlbumCollection(mergedSettings);
      }).catch(function () {
        return getAlbumCollection(widgetSettings);
      });
    } else {
      getAlbumCollection(widgetSettings);
    }
  };
};

var _isPlainObject = __webpack_require__(/*! lodash/isPlainObject */ 95);

var isPlainObject = _interopRequireDefault(_isPlainObject).default;

var _config = __webpack_require__(/*! ../common/config */ 3);

var config = _interopRequireDefault(_config).default;

var _migrator = __webpack_require__(/*! ../common/migrator */ 49);

var migrator = _interopRequireDefault(_migrator).default;

var _utils = __webpack_require__(/*! ../utils/utils */ 1);

var utils = _interopRequireDefault(_utils).default;

var _errors = __webpack_require__(/*! ./v2/shared/errors */ 9);

var BI_ERRORS = _errors.BI_ERRORS;
var errorReporter = _errors.errorReporter;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/***/ }),

/***/ 51:
/* no static exports found */
/* all exports used */
/*!***************************************************!*\
  !*** ./scripts/player/v2/shared/errors/errors.js ***!
  \***************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var BI_ERRORS = exports.BI_ERRORS = {
  widget: {
    musicAlbum: {
      get: {
        id: 1001,
        name: 'widget.musicAlbum.get',
        error: function error() {
          throw new Error(this.name);
        }
      }
    },
    settingsCollection: {
      get: {
        id: 1002,
        name: 'widget.settingsCollection.get',
        error: function error() {
          throw new Error(this.name);
        }
      }
    },
    content: {
      audio: {
        get: {
          id: 1003,
          name: 'widget.content.audio',
          error: function error() {
            throw new Error(this.name);
          }
        }
      },
      image: {
        get: {
          id: 1004,
          name: 'widget.content.image',
          error: function error() {
            throw new Error(this.name);
          }
        },
        noDimensions: {
          id: 1009,
          name: 'widget.content.image.noDimensions',
          error: function error() {
            throw new Error(this.name);
          }
        }
      },
      scripts: {
        wix: {
          id: 1007,
          name: 'widget.content.scripts.wix',
          error: function error() {
            throw new Error(this.name);
          }
        },
        player: {
          id: 1008,
          name: 'widget.content.scripts.player',
          error: function error() {
            throw new Error(this.name);
          }
        }
      }
    },
    statistic: {
      counters: {
        send: {
          id: 1005,
          name: 'widget.statistic.counters.send',
          error: function error() {
            throw new Error(this.name);
          }
        }
      },
      activity: {
        send: {
          id: 1006,
          name: 'widget.statistic.activity.send',
          error: function error() {
            throw new Error(this.name);
          }
        }
      }
    }
  }
};

/***/ }),

/***/ 59:
/* no static exports found */
/* all exports used */
/*!******************************!*\
  !*** external "deep-freeze" ***!
  \******************************/
/***/ (function(module, exports) {

module.exports = require("deep-freeze");

/***/ }),

/***/ 60:
/* no static exports found */
/* all exports used */
/*!**********************************!*\
  !*** external "lodash/throttle" ***!
  \**********************************/
/***/ (function(module, exports) {

module.exports = require("lodash/throttle");

/***/ }),

/***/ 7:
/* no static exports found */
/* all exports used */
/*!*************************************!*\
  !*** ./scripts/utils/deprecated.js ***!
  \*************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.enableDeprecationWarnings = enableDeprecationWarnings;
exports.deprecated = deprecated;

var _envConfig = __webpack_require__(/*! env-config */ 12);

var showDeprecationWarnings = _envConfig.showDeprecationWarnings;


var warningsEnabled = Boolean(showDeprecationWarnings);

function enableDeprecationWarnings() {
  warningsEnabled = true;
}

function deprecatedMethod(target, property, descriptor) {
  var originalMethod = descriptor.value;
  return _extends({}, descriptor, {
    value: function value() {
      if (warningsEnabled) {
        var propertyIn = target.constructor ? ' in \'' + target.constructor.name + '\'' : '';
        console.warn('Called deprecated method \'' + property + '\'' + propertyIn); // eslint-disable-line no-console
      }
      return originalMethod.apply(undefined, arguments);
    }
  });
}

function deprecatedProperty(target, property, descriptor) {
  var originalGet = descriptor.get;
  return _extends({}, descriptor, {
    get: function get() {
      if (warningsEnabled) {
        var propertyIn = target.constructor ? ' in \'' + target.constructor.name + '\'' : '';
        try {
          throw new Error();
        } catch (error) {
          console.warn('Called deprecated get property \'' + property + '\'' + propertyIn + ' ' + error.stack); // eslint-disable-line no-console
        }
      }
      return originalGet.call(this);
    }
  });
}

function deprecateFunction(original) {
  return function () {
    if (warningsEnabled) {
      var functionName = original.toString().match(/function\s*(.*)\(/)[1];
      try {
        throw new Error();
      } catch (error) {
        var message = functionName ? 'Called deprecated function \'' + functionName + '\'' : 'Called deprecated anonymous function';
        console.warn(message + ' ' + error.stack); // eslint-disable-line no-console
      }
    }
    return original.apply(this, arguments);
  };
}

function deprecated(target, property, descriptor) {
  if (!property && !descriptor) {
    return deprecateFunction(target);
  }
  return (descriptor.hasOwnProperty('value') ? deprecatedMethod : deprecatedProperty)(target, property, descriptor);
}

/***/ }),

/***/ 8:
/* no static exports found */
/* all exports used */
/*!*************************!*\
  !*** external "events" ***!
  \*************************/
/***/ (function(module, exports) {

module.exports = require("events");

/***/ }),

/***/ 9:
/* no static exports found */
/* all exports used */
/*!**************************************************!*\
  !*** ./scripts/player/v2/shared/errors/index.js ***!
  \**************************************************/
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _errorReporter = __webpack_require__(/*! ./error-reporter */ 15);

Object.defineProperty(exports, 'errorReporter', {
  enumerable: true,
  get: function get() {
    return _errorReporter.errorReporter;
  }
});

var _errors = __webpack_require__(/*! ./errors */ 51);

Object.defineProperty(exports, 'BI_ERRORS', {
  enumerable: true,
  get: function get() {
    return _errors.BI_ERRORS;
  }
});

/***/ }),

/***/ 95:
/* no static exports found */
/* all exports used */
/*!***************************************!*\
  !*** external "lodash/isPlainObject" ***!
  \***************************************/
/***/ (function(module, exports) {

module.exports = require("lodash/isPlainObject");

/***/ })

/******/ });
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ../~/wix-music-widget/lib/index.js
// module id = 38
// module chunks = 9